import type { ReviewExportPort } from '../../application/ports';

export class BrowserReviewExportAdapter implements ReviewExportPort {
  exportJson(filename: string, content: string): void {
    const blob = new Blob([content], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    URL.revokeObjectURL(url);
  }
}
